import styles from "./Containers.module.css";

const ToolInventoryCard = ({ children }) => {
  return <div className={styles.toolInventoryCard}>{children}</div>;
};

export default ToolInventoryCard;
